/* src/app/workshop/components/docs/view-documents/view-documents.component.scss */
/*# sourceMappingURL=view-documents.component.css.map */
